import React, { useEffect, useState, useRef, useCallback } from 'react';
import cn from 'classnames';

import './ImageDndUploader.scss';

type Props = {
  children: React.ReactNode;
  onFileDrop: Function;
};

function ImageDndUploader({ children, onFileDrop }: Props) {
  const [isDragOver, setIsDragOver] = useState(false);
  const imageDndUploaderRef = useRef(null);
  const dragCounter = useRef(0);

  const handleDragIn = useCallback(event => {
    dragCounter.current += 1;
    if (event.dataTransfer.items && event.dataTransfer.items.length > 0) setIsDragOver(true);
  }, []);

  const handleDragOut = useCallback(() => {
    dragCounter.current -= 1;
    if (dragCounter.current === 0) setIsDragOver(false);
  }, []);

  const handleDrop = useCallback(
    event => {
      setIsDragOver(false);
      const { files } = event.dataTransfer;
      if (files && files.length > 0) {
        const filteredFiles = [...files].filter(file => file.type.length);
        onFileDrop(filteredFiles);
        event.dataTransfer.clearData();
        dragCounter.current = 0;
      }
    },
    [onFileDrop]
  );

  useEffect(() => {
    const container = imageDndUploaderRef.current;
    container.addEventListener('dragenter', handleDragIn);
    container.addEventListener('dragleave', handleDragOut);
    container.addEventListener('drop', handleDrop);
    return () => {
      container.removeEventListener('dragenter', handleDragIn);
      container.removeEventListener('dragleave', handleDragOut);
      container.removeEventListener('drop', handleDrop);
    };
  }, [handleDragIn, handleDragOut, handleDrop]);

  return (
    <div
      className={cn('image-dnd-uploader w-100', { 'image-dnd-uploader--is-dragover': isDragOver })}
      ref={imageDndUploaderRef}
    >
      {children}
    </div>
  );
}

export default ImageDndUploader;
